<div class="secured-resource">
  <mat-progress-spinner *ngIf="loading"></mat-progress-spinner>

  <div
    *ngIf="!loading && isImage()"
    class="image-wrapper"
    (click)="openPreview()"
    matTooltip="{{ 'components.imagePreview.viewLarger' | translate }}"
  >
    <img [src]="dataUrl" (load)="imageReady = true" alt="" />
    <span class="image-wrapper__zoom">
      <mat-icon>zoom_in</mat-icon>
    </span>
  </div>

  <video *ngIf="!loading && isVideo()" [src]="dataUrl" controls></video>
</div>
